export default __webpack_public_path__ + "static/media/portfolio-smiles-5.6cadf248.jpg";